import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { ChevronUp, ChevronDown } from 'lucide-react';

const ScrollButtons = () => {
  const [showButtons, setShowButtons] = useState(false);
  const [atTop, setAtTop] = useState(true);
  const [atBottom, setAtBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Show buttons if scrolled more than 300px
      setShowButtons(scrollY > 300);
      
      // Check if at top (within 100px of top)
      setAtTop(scrollY < 100);
      
      // Check if at bottom (within 100px of bottom)
      setAtBottom(scrollY + windowHeight >= documentHeight - 100);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial position

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  if (!showButtons) return null;

  return (
    <div className="fixed right-20 sm:right-24 bottom-20 sm:bottom-24 z-40 flex flex-col space-y-2">
      {!atTop && (
        <Button
          onClick={scrollToTop}
          className="bg-teal-500 hover:bg-teal-600 text-white p-2 sm:p-3 rounded-full shadow-lg transition-all duration-200 hover:scale-110"
          size="sm"
          title="Scroll to top"
        >
          <ChevronUp className="w-4 h-4 sm:w-5 sm:h-5" />
        </Button>
      )}
      
      {!atBottom && (
        <Button
          onClick={scrollToBottom}
          className="bg-teal-500 hover:bg-teal-600 text-white p-2 sm:p-3 rounded-full shadow-lg transition-all duration-200 hover:scale-110"
          size="sm"
          title="Scroll to bottom"
        >
          <ChevronDown className="w-4 h-4 sm:w-5 sm:h-5" />
        </Button>
      )}
    </div>
  );
};

export default ScrollButtons;